export default "__VITE_ASSET__CQMWgngJ__"